<div
  *ngIf="activeFullscreenLoader$ | async as activeFullscreenLoader"
  class="app-fullscreen-loader-overlay @container"
>
  <div
    class="loader-surface mx-auto flex w-full flex-col items-center gap-4 px-5 py-6 text-center shadow-lg"
  >
    <mat-spinner diameter="56"></mat-spinner>

    <p *ngIf="activeFullscreenLoader.config.message" class="loader-message m-0">
      {{ activeFullscreenLoader.config.message }}
    </p>
  </div>
</div>
